import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import InformationModal from '../../../../components/shared/informationmodal/InformationModal'
import ModalTopText from '../../../../components/shared/modaltoptext/ModalTopText'
import Form from 'react-bootstrap/Form'
import {DatePicker} from '@mui/x-date-pickers'
import moment from 'moment'
import {loaders} from '../../../../helpers/constants'

export default function ApiUserModal({setVisibility, show, apiUserData, createApiUser, editApiUser, openDeleteApiUserModal}) {

    const {t} = useTranslation(['common', 'userpage'])
    const {loading} = useSelector(state => state.loading)
    const isSaving = loading.includes(loaders.createEditApiUser)

    useEffect(() => {
    }, [show, apiUserData]);

    return (
        <InformationModal dialogClassName="group-selector-modal" show={show}
                          title={t('userpage:user_management.api_user_modal.modal_title')}
                          body={
                              <React.Fragment>
                                  <ModalTopText body={t('userpage:user_management.api_user_modal.body')}/>
                                    {
                                        apiUserData == null ?
                                            <div className="modal-body">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p>{t('userpage:user_management.api_user_modal.no_api_user')}</p>
                                                        </div>
                                                    </div>
                                            </div>
                                            :
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label htmlFor="apiClientId">{t('userpage:user_management.api_user_modal.api_user_client')}</label>
                                                            <input type="text" className="form-control" id="apiClientId" value={apiUserData.client} readOnly/>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                        <Form.Group>
                                                            <label htmlFor="apiUserReadOnlyId">{t('userpage:user_management.api_user_modal.api_user_read_only')}</label>
                                                            <Form.Switch
                                                                id="apiUserReadOnlyId"
                                                                name="apiUserReadOnly"
                                                                checked={apiUserData.read_only || false} // Sikrer, at `checked` altid er en boolean
                                                                onChange={(e) => editApiUser(e.target.checked, false)}
                                                             />
                                                        </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label htmlFor="apiClientSecret">{t('userpage:user_management.api_user_modal.api_user_client_secret')}</label>
                                                            <input type="text" className="form-control" id="apiClientId" value={apiUserData.client_secret} readOnly/>
                                                            <button className="btn btn-primary mt-2" onClick={() => editApiUser(apiUserData.read_only, true)}>{t('userpage:user_management.api_user_modal.create_new_secret')}</button>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                                <label htmlFor="apiClientSecretExpiration">{t('userpage:user_management.api_user_modal.api_user_secret_expiration')}</label>
                                                                <Form.Group>  
                                                                    <DatePicker
                                                                        id="apiClientSecretExpiration"
                                                                        className="bg-white"
                                                                        disableHighlightToday={true}
                                                                        format={'DD-MM-YYYY'}
                                                                        readOnly={true}
                                                                        value={moment((apiUserData.secret_expiration ?? 0).toString(), 'YYYY-MM-DDTHH:mm:ss.SSSZ')}
                                                                    />
                                                                </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  
                                    }
                                                                        
                                    
                                </React.Fragment>
                          } size="lg"
                          accept={() => apiUserData == null ? createApiUser() : openDeleteApiUserModal()}
                          accepBtnText={apiUserData == null ? t('common:buttons.create') : t('common:buttons.delete')}
                          acceptBtnLoading={isSaving}
                          dismiss={() => setVisibility()}/>
    )
}
